import { ESTIMATE_YEARS } from './constants';

/**
 * Format year for a projection year
 * @param {number} year Year to format
 * @returns {string} Formated year
 */
export const formatProjection = (year) => `${ESTIMATE_YEARS.includes(year) ? '*' : ''}${year}`;
